import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";

/** @returns True if there is a dragging event happening on the window */
export function useIsUserDragging() {
  const $ = _c(2);
  const [isAppDragging, setIsAppDragging] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      let timeoutId = undefined;
      const onDragEnterOrOver = function onDragEnterOrOver(event) {
        if (!event.dataTransfer) {
          return;
        }
        event.preventDefault();
        event.dataTransfer.dropEffect = "none";
        event.dataTransfer.effectAllowed = "none";
        event.stopPropagation();
        if (timeoutId !== undefined) {
          clearTimeout(timeoutId);
          timeoutId = undefined;
        }
        setIsAppDragging(true);
      };
      const onDragLeave = function onDragLeave(event_0) {
        if (!event_0.dataTransfer) {
          return;
        }
        event_0.preventDefault();
        event_0.dataTransfer.dropEffect = "none";
        event_0.dataTransfer.effectAllowed = "none";
        event_0.stopPropagation();
        timeoutId = window.setTimeout(() => setIsAppDragging(false), 100);
      };
      window.addEventListener("dragenter", onDragEnterOrOver);
      window.addEventListener("dragover", onDragEnterOrOver);
      window.addEventListener("dragleave", onDragLeave);
      return () => {
        window.removeEventListener("dragenter", onDragEnterOrOver);
        window.removeEventListener("dragover", onDragEnterOrOver);
        window.removeEventListener("dragleave", onDragLeave);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isAppDragging;
}